export default __webpack_public_path__ + "static/media/kick.ea1dad8b.mp3";